// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("D:\\ionic\\Project\\landing-page\\node_modules\\gatsby-plugin-offline\\app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-default-index-jsx": () => import("D:\\ionic\\Project\\landing-page\\src\\pages\\default-index.jsx" /* webpackChunkName: "component---src-pages-default-index-jsx" */),
  "component---src-pages-index-jsx": () => import("D:\\ionic\\Project\\landing-page\\src\\pages\\index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "D:\\ionic\\Project\\landing-page\\.cache\\data.json")

